export default "__VITE_ASSET__f9550995__"